import React from 'react';

import Modal from '@/components/switchback/Modal';
import { ModalSize } from '@/components/switchback/Modal/Modal';

interface IProps extends React.HTMLAttributes<HTMLElement> {
  isOpen: boolean;
  title: string;
  subTitle: string;
  onCloseModal?: () => any;
  // MP-4819: when false, the modal cannot be dismissed — no X, no backdrop
  // click, no Esc. Used by the blocking phone-collection gate. Defaults to true.
  dismissable?: boolean;
  /**
   * Lets focus leave the dialog. Needed only when a child portals interactive content to
   * document.body: MUI's trap listens for focus on document in the capture phase and pulls
   * anything outside the root back, so a portalled input can never hold focus.
   */
  disableEnforceFocus?: boolean;
}

const PhoneVerificationModal: React.FC<IProps> = ({
  title,
  subTitle,
  isOpen,
  onCloseModal,
  dismissable = true,
  disableEnforceFocus,
  children,
}) => {
  return (
    <Modal
      size={ModalSize.medium}
      title={title}
      open={isOpen}
      data-testid="ask-host-modal"
      onClose={dismissable ? onCloseModal : undefined}
      disabledManualClose={!dismissable}
      disableEscapeKeyDown={!dismissable}
      disableEnforceFocus={disableEnforceFocus}>
      <p className="my-4 text-gray-900">{subTitle}</p>
      {children}
    </Modal>
  );
};

export default PhoneVerificationModal;
